import {
    QUEUE_NAME_REFERRAL_WMNS_GEN,
    QUEUE_NAME_REFERRAL_WMNS_GEN_2
} from "./constant";

export const getRealQueueName = (queueAlias) => {
    if (queueAlias === QUEUE_NAME_REFERRAL_WMNS_GEN_2) {
        return QUEUE_NAME_REFERRAL_WMNS_GEN;
    }
    return queueAlias;
}